<template>
    <ConfirmDialog></ConfirmDialog>
</template>

<script>
export default {
  name: 'DialogConfirmation',
  methods: { 
    confirmer(next, objInitial, objLocal) {
        if (this.$commun.isChanged(objInitial, objLocal)) {
            this.$confirm.require({
                message: 'Voulez-vous vraiment fermer la page sans sauvegarder?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    return next();
                },
                reject: () => {
                    return next(false);
                },
                onHide: () => {
                }
            });
        } else {
            return next(); 
        }     
    },        
  }
}
</script>